import Banner from "../../components/Services/Banner/Banner";
import Advantages from "../../components/Services/Advantages/Advantages";
import HelmetLayout from "../../components/GlobalComponents/HelmetLayout";
import Tabs from "../../components/Services/Tabs/Tabs";

const Services = () => {
    return (
        <HelmetLayout
            name="Services"
            title="Ard Altaamir: Professional Building Services"
            description="Explore Ard Altaamir’s full range of expert building services: from plumbing and MEP to complete interior and exterior renovations."
            route="services"
        >
            <Banner />
            <Tabs />
            <Advantages />
        </HelmetLayout>
    );
};

export default Services;
